<div class="material-row">
  <a target="_blank" [href]="offlineUrl || file.fileurl" class="material-row__link" title='Download "{{file.displayname}}"' download>
    <i class="fa fa-file-download material-row__icon" aria-hidden="true"></i>
    <span class="material-row__name">{{file.displayname}}</span>
  </a>
  <button *ngIf="!confirmDelete && adminuser" type="button" (click)="popconfirmdelete(true)"
    class="material-row__delete" title="Delete" attr.aria-label="Delete {{file.displayname}}">
    <i class="fas fa-trash-alt" aria-hidden="true"></i>
  </button>
</div>
<div *ngIf="confirmDelete" class="mt-2 mb-3">
  <p class="alert text-center deleteConfirmText mb-2">Delete this file?</p>
  <div class="d-flex justify-content-center flex-wrap gap-.3">
    <button type="button" (click)="deleteconfimed(file.id)" class="btn btn--danger btn--sm text-xs m-0">Yes</button>
    <button type="button" (click)="popconfirmdelete(false)" class="btn btn--sm text-xs m-0">No</button>
  </div>
</div>
